let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6F9Q6")).then(() => parcelRequire('68T1m'));